<app-table-wrapper>
  <ng-template #tableHeader>
    <div class="p-3 subtle-title">{{ 'MySpace.PersonalizeApp' | translate }}</div>
  </ng-template>
  <ng-template #tableBody>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="tabChanged($event)" [(selectedIndex)]="selectedTabIndex">
      <mat-tab [disabled]="isFreePlan">
        <ng-template mat-tab-label>
          {{ 'MySpace.LogoImage' | translate }}
          @if (isFreePlan) {
            <mat-icon color="primary">lock</mat-icon>
          }
        </ng-template>
        <app-logo-editor></app-logo-editor>
      </mat-tab>
      <mat-tab [disabled]="isFreePlan">
        <ng-template mat-tab-label>
          {{ 'MySpace.LoginImage' | translate }}
          @if (isFreePlan) {
            <mat-icon color="primary">lock</mat-icon>
          }
        </ng-template>
        <ng-container *ngTemplateOutlet="photoEditor"></ng-container>
      </mat-tab>
      <!-- <mat-tab disabled>
      <ng-template mat-tab-label>
        {{ 'MySpace.CustomURL' | translate }}
        <mat-icon color="primary" *ngIf="isFreePlan">lock</mat-icon>
        <mat-icon color="primary" *ngIf="!isFreePlan">paid</mat-icon>
      </ng-template>
      <app-custom-url-setter></app-custom-url-setter>
    </mat-tab> -->
    </mat-tab-group>
  </ng-template>
</app-table-wrapper>

<ng-template #photoEditor>
  <div class="p-3">
    <!-- Tools Row (Side by Side) -->
    <div class="tools-grid">
      <!-- File Uploader -->
      <div>
        <div class="subtle-title mb-2">{{ 'MySpace.ChooseFile' | translate }}</div>
        <app-file-uploader [type]="'personalize-app'" (success)="imageUploadedSucessfully($event)" [language]="selectedLanguage" [folder]="getFullFolderName()"></app-file-uploader>
      </div>

      <!-- AI Generator -->
      <div>
        <div class="subtle-title mb-2">{{ 'MySpace.GenerateImage' | translate }}</div>
        @if (generateImageForm) {
          <form class="d-flex flex-column gap-2 align-items-start" [formGroup]="generateImageForm" (ngSubmit)="generateImage()">
            <div class="w-100">
              <mat-label class="form-label mb-1">{{ 'MySpace.AIModel' | translate }}</mat-label>
              <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
                <mat-select [formControl]="generateImageForm.controls['model']" [placeholder]="'MySpace.AIModel' | translate">
                  @for (item of AiModels; track item.value) {
                    <mat-option [value]="item.value">
                      {{ item.viewValue | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="w-100">
              <mat-label class="form-label mb-1">{{ 'MySpace.DescribeImage' | translate }}</mat-label>
              <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
                <textarea
                  class="prompt-input"
                  matInput
                  cdkTextareaAutosize
                  name="prompt"
                  [formControl]="generateImageForm.controls['prompt']"
                  [placeholder]="'MySpace.ImagePromptPlaceholder' | translate"
                  [disabled]="generatingImage"
                  required
                ></textarea>
              </mat-form-field>
            </div>
            <button mat-flat-button color="primary" [disabled]="generatingImage || generateImageForm.invalid">
              {{ 'MySpace.GenerateButton' | translate }}
            </button>
          </form>
        }
      </div>
    </div>

    <!-- Preview Section (Below) -->
    <div class="preview-section">
      <div>
        <div class="subtle-title mb-2">{{ 'MySpace.SelectImage' | translate }}</div>
        @if (generatingImage) {
          <mat-label>{{ 'MySpace.PleaseWaitwhileGeneratingImage' | translate }}</mat-label>
        }

        <div class="image-selector">
          <div class="image-comparison">
            <div class="image-child">
              <mat-label class="mb-1">{{ 'MySpace.CurrentImage' | translate }}</mat-label>
              <div class="image-wrapper">
                @if (currentAppImage) {
                  <app-image-viewer [src]="currentAppImage" [alt]="'MySpace.CurrentImage' | translate" [borderRadius]="'12px'" [objectFit]="'cover'" [fillContainer]="true"></app-image-viewer>
                } @else {
                  <div class="d-flex align-items-center justify-content-center bg-light rounded-3 text-muted" style="width: 100%; aspect-ratio: 1/1; border: 1px dashed #e6e8ef">
                    {{ 'MySpace.ImageNotFound' | translate }}
                  </div>
                }
              </div>
            </div>

            @if (currentTempAppImage) {
              <div class="image-child">
                <mat-label class="mb-1">{{ 'MySpace.YourNewImage' | translate }}</mat-label>
                <div class="image-wrapper">
                  <app-image-viewer [src]="currentTempAppImage" [alt]="'MySpace.YourNewImage' | translate" [borderRadius]="'12px'" [objectFit]="'cover'" [fillContainer]="true"></app-image-viewer>
                </div>
              </div>
            }
          </div>

          @if (currentAppImage || currentTempAppImage) {
            <div class="action-buttons">
              @if (currentTempAppImage) {
                <button [disabled]="loading" mat-flat-button color="primary" (click)="replaceImageWithUsers()">
                  {{ 'MySpace.ReplaceCurrentImage' | translate }}
                </button>
              }
              @if (currentAppImage) {
                <button [disabled]="loading" mat-flat-button color="primary" (click)="deleteCurrentImage()">
                  {{ 'MySpace.DeleteCurrentImage' | translate }}
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
